import { render, staticRenderFns } from "./UiCalendar.vue?vue&type=template&id=1e761afd&scoped=true"
import script from "./UiCalendar.vue?vue&type=script&lang=js"
export * from "./UiCalendar.vue?vue&type=script&lang=js"
import style0 from "./UiCalendar.vue?vue&type=style&index=0&id=1e761afd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e761afd",
  null
  
)

export default component.exports